angular.module('resources.Article', ['ngResource']).factory('Article', [
  '$resource',
  function($resource) {
    var Resource = $resource(
      '/api/account/my-articles/:id',
      { id: '@_id' },
      {
        query: {
          method: 'GET',
          isArray: false
        },
        queryVideo: {
          method: 'GET',
          isArray: false,
          url: '/api/account/my-videos'
        },
        update: {
          method: 'PUT',
          isArray: false
        },
        search: {
          method: 'GET',
          isArray: true,
          url: '/api/account/my-articles-search'
        },
        getAllArticles: {
          method: 'GET',
          isArray: false,
          url: '/api/diagrams/get-all-articles'
        },
        getAllEditions: {
          method: 'GET',
          isArray: false,
          url: '/api/editions/get-all-editions'
        },
        getAllRecuentos: {
          method: 'GET',
          isArray: false,
          url: '/api/recuentos/get-all-editions'
        },
        getInfoVideo: {
          method: 'GET',
          isArray: false,
          url: '/api/media/info/get-info-video'
        }
      }
    );
    return Resource;
  }
]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Article.js